﻿function setDisclaimerCookie(selectedValue) {
  var r = new Date();
  var name = "cookieconsent_status",
    value = selectedValue,
    domain = window.location.hostname,
    path = "/",
    secure = true;

  r.setDate(r.getDate() + 365);
  var a = [
    name + "=" + value,
    "expires=" + r.toUTCString(),
    "path=" + (path || "/"),
  ];
  domain && a.push("domain=" + domain), secure && a.push("secure");

  var disclaimerCookie = a.join(";");
  document.cookie = disclaimerCookie;
}

function showManageCookiesPanel() {
  var cookiesPanel = document.querySelector("#cookies-panel");
  var cookiesMessage = document.querySelector("#cookies-message");

  cookiesMessage.classList.add("hidden");
  cookiesPanel.classList.remove("hidden");
}

function closeCookiesPanel() {
  var disclaimerContainer = document.querySelector("#cookie-disclaimer");
  document.body.removeChild(disclaimerContainer);
}

function updateGoogleAnalyticsConfig() {
  if (gtag == null) return;

  gaConfig.name = "hirehive";
  gaConfig.storage = "cookie";
  gaConfig.analytics_storage = "granted";

  gtag("config", "G-H3XX83Q8PF", gaConfig);

  if (window.__company_ga != null) {
    gaConfig.name = "company";
    gtag("config", window.__company_ga, gaConfig);
  }
}

function cookiesFormSubmitted(event) {
  event.preventDefault();

  var selectedInput = event.target.querySelector(
    "input:not([disabled]):checked"
  );

  var selectedOption =
    selectedInput === null ? "functional" : selectedInput.value;

  setDisclaimerCookie(selectedOption);

  if (selectedOption === "analytics") updateGoogleAnalyticsConfig();

  closeCookiesPanel();
}

function acceptCookies() {
  setDisclaimerCookie("analytics");
  updateGoogleAnalyticsConfig();
  closeCookiesPanel();
}

function getCookie(name) {
  let cookie = {};
  document.cookie.split(";").forEach(function (el) {
    let split = el.split("=");
    cookie[split[0].trim()] = split.slice(1).join("=");
  });
  return cookie[name];
}

var consentLevel = getCookie("cookieconsent_status");

if (
  consentLevel == "analytics" ||
  consentLevel == "functional" ||
  consentLevel == "agreed"
) {  
  document.querySelector("#cookie-disclaimer").remove();
} else {
  document
    .querySelector("#manageCookies")
    .addEventListener("click", showManageCookiesPanel);
  document
    .querySelector("#closeCookies")
    .addEventListener("click", closeCookiesPanel);
  document
    .querySelector("#acceptCookies")
    .addEventListener("click", acceptCookies);
  document
    .querySelector('form[name="cookies-form"]')
    .addEventListener("submit", cookiesFormSubmitted);
}
